import "react-select-plus/dist/react-select-plus.css";

import React from "react";
import Select from "react-select-plus";

// const PromptTextCreator = () => {
//   return (
//     <div>
//       <Button fill>
//         +
//       </Button>
//       <FormattedMessage
//         id={"CustomSelect_prompt_label"}
//         description="new item prompt label"
//         defaultMessage={"Créer"}
//       />
//     </div>
//   );
// }

const SimpleSelect = ({
  name,
  value,
  onSelected,
  options,
  disabled,
  creatable,
  clearable,
  onNewOptionClick,
  multi,
  centered  
}) => {
  // console.log('SimpleSelect', disabled)
  const Component = creatable ? Select.Creatable : Select;

  const style = (centered === true) ? {textAlign: "center", fontWeight: "bold"}: {};
  return (
    <Component
      name={name}
      value={value}
      onChange={onSelected}
      multi={multi}
      options={options}
      onNewOptionClick={onNewOptionClick}
      // promptTextCreator={() => <PromptTextCreator/>}
      disabled={disabled === true}
      clearable={clearable}
      menuStyle={{ ...style, fontSize: "12px"}}
      valueRenderer={(value) =>
        <div style={{...style}} title={name === "bankAccounts" ? "" : (value.help !== undefined ? value.help : value.label)}>
          {value.label}
        </div>
      }
    />
  );
};

export default SimpleSelect;
